import React from 'react';

import { Message, MessageWrapperChooseContract } from './styles';

interface MessageChooseContractProps {
  message?: string;
  children?: React.ReactNode;
}

const MessageChooseContract = ({
  message,
  children
}: MessageChooseContractProps) => {
  return (
    <MessageWrapperChooseContract>
      {message ? <Message>{message}</Message> : null}
      {children}
    </MessageWrapperChooseContract>
  );
};

export default MessageChooseContract;
